import { SVGProps } from "react"

export const ReveniIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={800}
      height={800}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 30">
        <path
          d="M17.1986 10.664V8.38741C17.1986 2.76367 4.97662 1.00586 2.82876 1.00586C1.63888 1.00586 0.927781 1.877 0.927781 2.7191V4.99565C0.927781 7.47012 6.09445 8.02379 7.53667 11.1094C5.92035 15.6883 0 18.7276 0 21.1632V23.4392C0 24.3328 0.7606 25.0878 1.6608 25.0878C6.13661 25.0883 17.1986 16.238 17.1986 10.664Z"
          fill="currentColor"
        ></path>
        <path
          d="M2.83133 2.19434C5.0072 2.19434 16.0126 4.03668 16.0126 8.38737C16.0126 13.2135 5.46836 21.6234 1.66337 21.6234C1.41365 21.6234 1.19141 21.4039 1.19141 21.1632C1.19141 19.5524 8.93952 14.6788 8.93952 9.87019C8.93952 5.57854 2.11929 4.19663 2.11929 2.71906C2.11898 2.47353 2.38621 2.19434 2.83133 2.19434Z"
          fill="white"
        ></path>
      </svg>
    </svg>
  )
}
